import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { uiActions } from '../../actions';
import useDispatch from '../../hooks/useDispatch';
import { usePreferences } from '../../hooks/usePreferences';

const Description = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  padding: 0 5%;
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const More = styled.span`
  color: ${props => props.color};
  text-decoration: underline;
  :hover {
    opacity: 0.6;
  }
  cursor: pointer;
`;

const ColorBadge = styled.div`
  background-color: ${props => props.color};
  width: 12px;
  height: 6px;
  border-radius: 10px;
`;

const CCASSDescription: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { nopColorStyleV2, concentrationColorStyleV2 } = usePreferences();

  return (
    <>
      <Description>
        <ColorBadge color={nopColorStyleV2} />
        <span style={{ color: '#6c757d' }}>
          {t('nopDescription2')} (
          <More
            color={nopColorStyleV2}
            onClick={() => {
              dispatch(uiActions.floatTutorial.showTutorial(28));
            }}
          >
            {t('descriptionMore')}
          </More>
          )
        </span>
      </Description>
      <Description>
        <ColorBadge color={concentrationColorStyleV2} />

        <span
          style={{ color: '#6c757d' }}
          onClick={() => {
            dispatch(uiActions.floatTutorial.showTutorial(27));
          }}
        >
          {t('concentrationDescription2')} (
          <More color={concentrationColorStyleV2}>{t('descriptionMore')}</More>)
        </span>
      </Description>
    </>
  );
};

export default CCASSDescription;
